export const isBackgroundEffectsModalOpen = (state) => state.core.modal === 'BackgroundEffects';
